// MY region: everything that differs for this site. Registered in ../regionConfig.js.
export const config = {
  code: 'MY',
  sourceSite: 'digirep-my',
  currency: 'MYR',
  supportEmail: 'hello@digitalreporting.my',
  careEmail: 'hello@digitalreporting.my',
  moneyPrefix: 'RM',
  companyIdLabel: 'Registration number',
  searchProviderLabel: 'Manual registration entry',
  phonePlaceholder: '+60 12 345 6789',
  signupSubtitle: 'Malaysia MBRS XBRL managed filing services',
  primaryService: 'mbrs_fs',
  accountTypes: [
    { value: 'my_simplified_xbrl', label: 'Simplified XBRL', subtitle: 'Smaller companies and simpler annual filings', price: 25 },
    { value: 'my_full_xbrl_standalone', label: 'Full XBRL', subtitle: 'Standalone financial statements', price: 50 },
    { value: 'my_full_xbrl_consolidated', label: 'Full XBRL', subtitle: 'Consolidated financial statements', price: 75 },
  ],
  optionalServices: [
    {
      id: 'mbrs_simple_xbrl_filing',
      title: 'SSM MBRS Simple XBRL Filing Support',
      description: 'We support your Simple XBRL package through the SSM MBRS workflow',
      price: 15,
    },
    {
      id: 'mbrs_full_xbrl_filing',
      title: 'SSM MBRS Full XBRL Filing Support',
      description: 'We support your Full XBRL package through the SSM MBRS workflow',
      price: 20,
    },
  ],
  serviceCatalog: {
    mbrs_fs: { title: 'MBRS XBRL Preparation', price: 0 },
    mbrs_simple_xbrl_filing: { title: 'SSM MBRS Simple XBRL Filing Support', price: 15 },
    mbrs_full_xbrl_filing: { title: 'SSM MBRS Full XBRL Filing Support', price: 20 },
  },
  delivery: {
    standard: { label: 'Standard (48 hours)', shortLabel: 'Standard', hours: '48h', surcharge: 0 },
    express: { label: 'Express (24 hours)', shortLabel: 'Express', hours: '24h', surcharge: 25 },
  },
};

// Hostnames that identify this region and the host used for links back to it.
export const hosts = ['xbrl.digitalreporting.my', 'preview.digitalreporting.my'];
export const primaryHost = 'xbrl.digitalreporting.my';
